import {
  Facebook,
  Instagram,
  Linkedin,
  Video,
  Mail,
  Phone,
  MapPin,
  ArrowUp,
} from "lucide-react";
import React from "react";
import logo from "../../Assest/logo.png";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-gradient-to-r from-blue-600/95 to-purple-600/95 relative">
      {/* Main Footer Content */}
      <div className="bl-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <a href="/#home" className="inline-block mb-6">
              <img src={logo} alt="Company Logo" className="h-16 w-auto" />
            </a>
            <p className="text-white text-lg leading-relaxed mb-6">
              Empowering businesses through strategic consulting and innovative
              solutions that drive growth and success.
            </p>

            {/* Social Media */}
            <div className="flex items-center space-x-4">
              {[
                {
                  icon: Facebook,
                  href: "https://www.facebook.com/profile.php?id=61578605154858",
                  label: "Facebook",
                  bg: "bg-blue-600",
                  hoverBg: "hover:bg-blue-700",
                },
                {
                  icon: Video,
                  href: "https://www.tiktok.com/@rtventure?_t=ZS-8xzuHFMXiyN&_r=1",
                  label: "TikTok",
                  bg: "bg-blue-500",
                  hoverBg: "hover:bg-blue-600",
                },
                {
                  icon: Linkedin,
                  href: "https://www.linkedin.com/company/rtechventure/",
                  label: "LinkedIn",
                  bg: "bg-blue-700",
                  hoverBg: "hover:bg-blue-800",
                },
                {
                  icon: Instagram,
                  href: "https://www.instagram.com/ramdhunitechventure?igsh=ZG0yZ202NnlqaHVk",
                  label: "Instagram",
                  bg: "bg-gradient-to-r from-purple-500 to-pink-500",
                  hoverBg: "hover:from-purple-600 hover:to-pink-600",
                },
              ].map((social, index) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`p-3 ${social.bg} ${social.hoverBg} rounded-lg text-white transition-all duration-300 transform hover:scale-110 shadow-lg`}
                    aria-label={social.label}
                  >
                    <IconComponent size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Quick Links</h3>
            <nav className="space-y-3">
              {[
                { name: "Home", href: "/#home" },
                { name: "About Us", href: "/#aboutus" },
                { name: "Services", href: "/#service" },
                { name: "Contact", href: "/#contact" },
                { name: "Careers", href: "/careers" },
              ].map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="block text-white hover:text-gray-400 hover:translate-x-2 transition-all duration-300 text-lg"
                >
                  {link.name}
                </a>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Our Services</h3>
            <nav className="space-y-3">
              {[
                "Workforce Solutions",
                "Strategic Partnerships",
                "Business Advisory Services",
                "Innovation Strategies",
                "Tech Consulting",
              ].map((service, index) => (
                <a
                  key={index}
                  href="#service"
                  className="block text-white hover:text-gray-400 hover:translate-x-2 transition-all duration-300 text-lg"
                >
                  {service}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Contact Info</h3>
            <div className="space-y-4">
              {/* Address */}
              <div className="flex items-start gap-3">
                <MapPin size={20} className="text-white mt-1 flex-shrink-0" />
                <div>

                  <p className="text-white mt-1">
                    <a
                      href="https://www.google.com/maps/place/Dallas,+Texas"
                      target="_blank"
                      rel="noreferrer"
                      className="hover:text-gray-400 transition-colors duration-300"
                    >
                      Dallas, Texas, USA
                    </a>
                  </p>


                </div>
              </div>

              {/* Phone */}
              <div className="flex items-center gap-3">
                <Phone size={20} className="text-white flex-shrink-0" />
                <div className="space-y-1">

                  <a
                    href="tel:+1-210-448-1184"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block text-white hover:text-gray-400 transition-colors duration-300"
                    title="Chat on WhatsApp"
                  >
                    +1-210-448-1184
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center gap-3">
                <Mail size={20} className="text-white flex-shrink-0" />
                <a
                  href="mailto:Application@rtventure.net"
                  className="text-white hover:text-gray-400 transition-colors duration-300"
                >
                  Application@rtventure.net
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t bg-gradient-to-r from-blue-600/95 to-purple-600/95">
        <div className="bl-container py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-white text-center md:text-left">
              <p>
                &copy; {new Date().getFullYear()} RamdhuniTech Venture. All
                rights reserved.
              </p>
            </div>

            <div className="flex items-center space-x-6">
              <a
                href="/privacy"
                className="text-white hover:text-gray-400 transition-colors duration-300"
              >
                Privacy Policy
              </a>
              <a
                href="/terms"
                className="text-white hover:text-gray-400 transition-colors duration-300"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 p-3 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-110 z-50"
        aria-label="Scroll to top"
      >
        <ArrowUp size={24} />
      </button>
    </footer>
  );
}
